export const sortTypes = ['hot', 'new', 'active', 'topAll'];
